import React, { useState } from 'react';

import { Box } from '@mantine/core';

import EventCell from './components/EventCell';
import WorkoutAssignedCell from './components/WorkoutAssignedCell';
import WorkoutPreviewModal from '../../../WorkoutPreviewModal';
import { AgendaEvent, WorkoutAssignment } from '../../interface';
import useProgramAgendaStyles from '../../styles';

interface IAgendaItemProps {
  event: AgendaEvent;
  assignment: WorkoutAssignment | null;
}

const AgendaItem = ({ event, assignment }: IAgendaItemProps): JSX.Element => {
  const { classes } = useProgramAgendaStyles();
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  return (
    <Box className={`${classes.agendaItem} ${classes.grid}`} data-cy='programAgendaItem'>
      <EventCell
        color={event.kiloClassType.color}
        programName={event.programName}
        totalPrograms={event.totalPrograms}
        hasAssignment={!!assignment}
        onClick={() => {
          if (assignment) setIsPreviewOpen(true);
        }}
      />

      <WorkoutAssignedCell
        assignment={assignment}
        kiloClassTypeId={event.kiloClassType.kiloClassTypeId}
        kiloClassTypeName={event.kiloClassType.name}
        date={event.programDate}
        onPreviewOpen={() => setIsPreviewOpen(true)}
      />

      <WorkoutPreviewModal
        workoutId={assignment?.workoutId ?? null}
        opened={isPreviewOpen}
        onClose={() => setIsPreviewOpen(false)}
      />
    </Box>
  );
};

export default AgendaItem;
